// extracted by mini-css-extract-plugin
export default {"r_l":"_4734aa2044 a6deee0fc7","t":"b23bd3b666"};